<template>
  <b-tooltip position="is-right" animated size="is-large" multilined type="is-light" square>
    <template v-slot:content>
      <div v-if="airportName">
        <span class="mdi mdi-airplane"></span> {{ airportName }}
      </div>
      <div v-if="formattedLocation">
        <span class="mdi mdi-map-marker"></span> {{ formattedLocation }}
      </div>
    </template>
    <div class="has-text-weight-bold">
      {{ airportCode }}
    </div>
  </b-tooltip>
</template>

<script>
export default {
  name: "AirportDetails",
  props: {
    airportCode: String,
  },
  computed: {
    // Get the airport details based on the airportCode
    airportDetails() {
      return (
        this.$globals.airports.find(
          (airportItem) => airportItem.code === this.airportCode
        ) || {}
      );
    },
    // Compute the airportName directly from airportDetails
    airportName() {
      return this.airportDetails.airportName || "";
    },
    // Compute the formatted location
    formattedLocation() {
      if (!this.airportDetails.city) return "Location not available";
      let location = `${this.airportDetails.city}`;
      if (this.airportDetails.state) {
        location += `, ${this.airportDetails.state}`;
      }
      location += `, ${this.airportDetails.countryName}`;
      return location;
    },
  },
};
</script>

<style>
.b-tooltip.is-multiline .tooltip-content {
  text-align: left !important;
}
</style>
